import { render, staticRenderFns } from "./fishing-general.vue?vue&type=template&id=777f3e7c&scoped=true"
import script from "./fishing-general.vue?vue&type=script&lang=js"
export * from "./fishing-general.vue?vue&type=script&lang=js"
import style0 from "./fishing-general.vue?vue&type=style&index=0&id=777f3e7c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "777f3e7c",
  null
  
)

export default component.exports